import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common';
import { Routes, RouterModule,PreloadAllModules} from '@angular/router';
import { HousekeepingRoutingModule } from './housekeeping-routing.module';
import { HousekeepingComponent } from './components/housekeeping.component';
import { LoginComponent } from './components/login.component';
import { LogoutComponent } from './components/logout.component';
import { ProfileComponent } from './components/profile.component';
import { ResetPasswordComponent } from './components/reset-password.component';
import { PreferencesComponent } from './components/preferences.component';
import { FooterComponent } from './components/footer.component';
import { AjaxService } from './services/ajax.service';
import { FileUploadService } from './services/file-upload.service';
import { EmitterService } from './services/emitter.service';
import {GlobalDataService} from './services/global-data.service';
import { ExceldownloadService } from './services/exceldownload.service';
import { HeaderComponent } from './components/header.component';
import { AppRoutingModule } from '../../app-routing.module';
import { UnAuthorizeComponent } from './components/un-authorize.component';
import {RoleGuardService} from '../../role-guard.service';
import { TransactionHistoryComponent } from './utility/transaction-history/transaction-history.component';
import { SurveyHistoryComponent } from './utility/survey-history/survey-history.component';

const routes: Routes = [
   { path: 'login', children: [
                               { path: '', component: LoginComponent ,canActivate :[RoleGuardService]},
                              ]
   },
   { path: 'logout', component: LogoutComponent },

   { path: 'unauth', component: UnAuthorizeComponent},
   { path: 'forgotPassword', component: ResetPasswordComponent },
   { path: 'resetPassword/:accesskey/:usertype', component: ResetPasswordComponent },
   { path: 'preferences', component: PreferencesComponent ,canActivate :[RoleGuardService]},
   { path: 'profile', component: ProfileComponent,canActivate :[RoleGuardService]},

];
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    HttpClientModule,
    BrowserModule,
    HousekeepingRoutingModule,

    RouterModule.forRoot(routes,
      {
        useHash: false,
        preloadingStrategy: PreloadAllModules
      })
  ],
  exports: [RouterModule, FooterComponent, HeaderComponent, TransactionHistoryComponent, SurveyHistoryComponent],
  providers: [GlobalDataService, AjaxService, EmitterService, FileUploadService, ExceldownloadService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [HousekeepingComponent, LoginComponent,
    LogoutComponent, ProfileComponent, ResetPasswordComponent,
    PreferencesComponent, FooterComponent, HeaderComponent, UnAuthorizeComponent,
    TransactionHistoryComponent, SurveyHistoryComponent]
})
export class HousekeepingModule { }



// WEBPACK FOOTER //
// ./src/app/modules/housekeeping/housekeeping.module.ts